import type { Checklist } from '../types';

/**
 * Realistic mock data keyed by taskId. Used when VITE_USE_MOCK === 'true' so the
 * checklist UI is fully testable end-to-end (multiple checklists, mixed progress).
 */
export const mockChecklistsByTask: Record<string, Checklist[]> = {
  '1': [
    {
      id: '101',
      taskId: '1',
      name: 'Diseño',
      order: 0,
      totalItems: 2,
      checkedItems: 1,
      progress: 50,
      createdAt: '2026-02-13T09:00:00Z',
      items: [
        {
          id: '1001',
          checklistId: '101',
          title: 'Crear componentes',
          isChecked: true,
          order: 0,
          createdAt: '2026-02-13T09:05:00Z',
          updatedAt: '2026-02-13T10:00:00Z',
        },
        {
          id: '1002',
          checklistId: '101',
          title: 'Armar la vista del dashboard',
          isChecked: false,
          order: 1,
          createdAt: '2026-02-13T09:06:00Z',
          updatedAt: null,
        },
      ],
    },
    {
      id: '102',
      taskId: '1',
      name: 'QA',
      order: 1,
      totalItems: 1,
      checkedItems: 0,
      progress: 0,
      createdAt: '2026-02-13T09:10:00Z',
      items: [
        {
          id: '1003',
          checklistId: '102',
          title: 'Revisar responsive en móvil',
          isChecked: false,
          order: 0,
          createdAt: '2026-02-13T09:11:00Z',
          updatedAt: null,
        },
      ],
    },
  ],
};
